module.exports = __webpack_public_path__ + "static/media/theway.ead03535.png";